import React, { Fragment } from 'react'
import QuantityChanger from '../Components/QuantityChanger'
import { translate } from '../Services/translation'

const MiniCartOrderRow = ({
    orderRow,
    removeOrderRow,
    updateOrderRowQuantity,
}) => {
    const getPriceSegment = (orderRow) => {
        if (orderRow.campaignPrice) {
            return (
                <Fragment>
                    <div className="cart__info-row-details-price--campaign-price">
                        {orderRow.totalPrice}
                    </div>
                    <div className="cart__info-row-details-price--old-price">
                        {orderRow.totalOldPrice}
                    </div>
                </Fragment>
            )
        }
        return orderRow.totalPrice
    }

    return (
        <div>
            <div className="cart__info-row">
                <a className="cart__info-row-link" href={orderRow.url}>
                    <img
                        className="cart__info-row-image"
                        src={orderRow.image}
                    />
                </a>
                <div className="cart__info-row-details">
                    <a
                        className="cart__info-row-details-link"
                        href={orderRow.url}
                    >
                        {orderRow.name}
                    </a>
                    <button
                        onClick={() => removeOrderRow(orderRow.rowSystemId)}
                        className="cart__info-row-delete icon-bin"
                    ></button>
                    <div className="cart__info-row-details-quantity-total">
                        <div className="cart__info-row-details-quantity">
                            {orderRow.isFreeGift ? (
                                <div>{orderRow.quantity}</div>
                            ) : (
                                <QuantityChanger
                                    {...{
                                        quantity: orderRow.quantity,
                                        updateQuantity: (updatedQuantity) =>
                                            updateOrderRowQuantity(
                                                orderRow.rowSystemId,
                                                updatedQuantity
                                            ),
                                        rowSystemId: orderRow.rowSystemId,
                                    }}
                                />
                            )}
                        </div>
                        <div className="cart__info-row-details-price">
                            {getPriceSegment(orderRow)}
                        </div>
                    </div>
                </div>
            </div>
            <hr className="small-12" />
        </div>
    )
}

export default MiniCartOrderRow
